import React from 'react';
import { useStore } from 'effector-react';
import { formatSize } from 'pano-utils';
import { ImageType } from '@types';
import { THUMB_SIZE_LIMIT, TITLE_LENGTH } from '@constants';
import Image from '@components/Image';
import Button from '@components/Button';
import Tip from '@components/Tip';
import TextLink from '@components/TextLink';
import { $tourData } from '@stores/dataStores';
import selectFile from '@utils/selectFile';
import { sendWarning } from '@components/Noti';
import getTid from '@utils/getTid';
import Input from '@components/Input';
import Textarea from '@components/Textarea';
import type { OnShareSettingChange, ShareSetting } from './types';
import { uploadThumb } from '../../alioss';

type Props = {
  settings: ShareSetting;
  onChange: OnShareSettingChange;
};

export function ShareInfoSetting({ settings, onChange }: Props) {
  const { thumbUrl = '' } = useStore($tourData);
  const { shareConfig } = settings;

  const changeThumb = async () => {
    const files = await selectFile({
      accept: 'image/jpeg, image/png, image/gif',
    });
    const file = files[0];
    if (file.size > THUMB_SIZE_LIMIT) {
      sendWarning(`图片过大（不能大于${formatSize(THUMB_SIZE_LIMIT)})`);
    }
    const url = await uploadThumb({ file, prefix: `/tour/${getTid()}` });
    onChange((draft) => {
      draft.shareConfig.thumb = url;
    });
  };

  return (
    <div className="flex h-full p-20">
      <div className="flex grow flex-col">
        <div>标题</div>
        <Input
          className="mt-10 h-30"
          placeholder="为空时自动获取作品标题作为分享标题"
          value={shareConfig.title}
          maxLength={TITLE_LENGTH}
          onChange={(e) => {
            onChange((draft) => {
              draft.shareConfig.title = e.target.value;
            });
          }}
        />
        <div className="mt-20">描述</div>
        <Textarea
          className="mt-10 grow"
          placeholder="为空时自动获取作品简介作为分享描述"
          value={shareConfig.remark}
          maxLength={10000}
          onChange={(e) => {
            onChange((draft) => {
              draft.shareConfig.remark = e.target.value;
            });
          }}
        />
      </div>
      <div className="ml-20 flex flex-col items-center">
        <div className="self-start">封面</div>
        <Image
          className="mt-5 h-130 w-130"
          type={ImageType.thumb}
          src={shareConfig.thumb || thumbUrl}
        />
        <Button className="mt-10 w-full" onClick={changeThumb}>
          修改封面
        </Button>
        <Tip className="mt-5">建议尺寸：512 x 512</Tip>
        {!!shareConfig.thumb && (
          <TextLink
            className="text-sm"
            onClick={() => {
              onChange((draft) => {
                draft.shareConfig.thumb = '';
              });
            }}
          >
            删除自定义封面
          </TextLink>
        )}
      </div>
    </div>
  );
}
